module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.be/fr_be/entreprise-grohe/protections-des-donnees.html",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": "https://www.grohe.be/fr_be/entreprise-grohe/protections-des-donnees.html",
	"footer.copyright": "&copy; Grohe N.V. - S.A.",
	"homepage.headline": "Configurateur système sanitaire GROHE",
	"homepage.introtext": "Répondez à quelques questions simples dans l'aide à la décision et découvrez le système sanitaire de GROHE qui s'accorde le mieux à vos souhaits ou bien quelle combinaison vous pouvez réaliser.",
	"homepage.buttonStart": "Commencer",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page non trouvée",
	"404.link.goBack": "Voir les résultats",
	"configurator.button.seeResults": "Voir les résultats",
	"question1.question": "Avez-vous une arrivée d'eau froide et d'eau chaude dans votre cuisine ?",
	"question1.option1.text": "J'ai une arrivée d'eau chaude dans ma cuisine",
	"question1.option2.text": "J'ai uniquement une arrivée d'eau froide dans ma cuisine",
	"question2.question": "Quelle solution pour votre cuisine cherchez-vous?",
	"question2.option1.text": "De l'eau bouillante pour la préparation d'aliments et de boissons",
	"question2.option2.text": "De l'eau réfrigérée et pétillante à boire",
	"question2.option3.text": "Aussi bien de l'eau réfrigérée et pétillante que de l'eau bouillante",
	"question3.question": "Voulez-vous conserver votre mitigeur de cuisine existant?",
	"question3.option1.text": "Je veux conserver mon mitigeur actuel",
	"question3.option2.text": "Je veux remplacer mon mitigeur actuel par un nouveau",
	"question4.question": "Quel devrait être le mitigeur le plus important?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Quel est votre type d'écoulement préféré?",
	"question5.option1.text": "Forme L",
	"question5.option2.text": "Forme U",
	"question5.option3.text": "Forme C",
	"question6.question": "What´s your prefered spout design for the Mono faucet?",
	"question6.option1.text": "L-shaped spout",
	"question6.option2.text": "C-shaped spout",
	"question7.question": "Quelle est la finition que vous préférez?",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "Supersteel",
	"question8.question": "De combien de litres d'eau bouillante avez-vous besoin?",
	"question8.option1.text": "Taille M (3 litres)",
	"question8.option2.text": "Taille L (5,5 litres)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water? (only applicable for NL)",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"results.title": "{productGroupsCount, plural, \none {Vos résultats} \nother {Votre résultat}\n}",
	"results.proposal.title": "Proposition {number}",
	"results.proposal.title.single": "Proposition",
	"results.bundle.title": "Pour une installation correcte, il vous faut encore ce qui suit",
	"results.newConfiguration.title": "Vous souhaitez faire une nouvelle configuration ?",
	"results.newConfiguration.buttonText": "Configurez un nouveau système sanitaire",
	"results.product.number": "Référence: #{number}",
	"results.product.button.productInformation": "Information produit",
	"results.product.button.dealerLocator": "Trouvez une salle d'exposition",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Télécharger le PDF",
	"results.product.information": "Information produit",
	"results.product.dealer": "Trouvez une salle d'exposition",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.fr_be.json
// module id = 772
// module chunks = 0